import React, {useEffect, useState} from 'react';
import {useSearchParams} from "react-router-dom";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import {whirlpool} from 'hash-wasm';
import Modal from 'react-modal';
import MainLink from "./Link";
import {type} from "@testing-library/user-event/dist/type";
import GenerateQR from './TwoFactorAuth';

const ucp_api = `${MainLink()}api/ucp/`;
const google_two_factor_api = `${MainLink()}api/google-two-factor/`;
const acp_api = `${MainLink()}api/acp/`;
const ToastMessage = ({ message, type, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, 3000);
        return () => clearTimeout(timer);
    }, [onClose]);

    return <div className={`toast-message ucp-pages ${type}`}>{message}</div>;
};



function UCPMainRender() {
    const ucp_get_characters = ucp_api + "get-user-characters";
    const acp_get_adm_level = ucp_api + "get-user-characters";
    const [characters, setCharacters] = useState([]);
    const [adm, setAdm] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(ucp_get_characters, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                    body: JSON.stringify({
                        user_id: localStorage.getItem("user-id"),
                        user_name: localStorage.getItem("user-login"),
                        user_password: localStorage.getItem("user-password"),
                    }),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                setCharacters(result.characters || []);
            } catch (err) {
                console.error(err.message);
            }
        };
        const checkAdmin = async () => {
            try {
                const response = await fetch(acp_api + "check-admin", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                    body: JSON.stringify({
                        user_id: localStorage.getItem("user-id"),
                        user_name: localStorage.getItem("user-login"),
                        user_password: localStorage.getItem("user-password"),
                    }),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                if (result > 0) setAdm(true)
            } catch (err) {
                console.error(err.message);
            }
        };
        fetchData();
        checkAdmin();
    }, []);
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [characterID, setCharacterID] = useState(0)
    const openSubmitModal = (id) => {
        setCharacterID(id)
        setModalIsOpen(true)
    }
    const closeSubmitModal = () => {
        setModalIsOpen(false)
    }

    const handleDeleteCharacter = async () => {
        try {
            const response = await fetch(ucp_api + "delete-character", {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                },
                body: JSON.stringify({
                    user_id: localStorage.getItem("user-id"),
                    user_name: localStorage.getItem("user-login"),
                    user_password: localStorage.getItem("user-password"),
                    character_id: characterID,
                }),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const result = await response.json();
            if (result === true) {
                window.location.href = "/../../../ucp"
            }
        } catch (err) {
            console.error(err.message);
        }
    }

    const placeholdersNeeded = Math.max(0, 4 - characters.length);
    const submitModalContent = (
        <div className='login-modal-content-container'>
            <span className='auth-title' style={{marginBottom: "0px", marginTop: "50px"}}>ВЫ УВЕРЕНЫ, ЧТО ХОТИТЕ УДАЛИТЬ ПЕРСОНАЖА?</span>
            <span style={{display: "block", marginTop: "20px", marginBottom: "25px"}}>Это действие нельзя будет отменить.</span>
            <button className='ucp-simple-yellow-button inline-two-buttons ' type='submit'
                    style={{marginRight: "8%", marginLeft: "0", marginTop: "1%"}} onClick={handleDeleteCharacter}>ДА
            </button>
            <button className='ucp-simple-yellow-button inline-two-buttons ucp-white-modified-button' type='submit'
                    onClick={closeSubmitModal}>НЕТ
            </button>
        </div>
    );


    return (
        <div className='ucp-main'>
            <span className="ucp-title" style={{textAlign: "start", display: "inline-block", width: "45vw"}}>ВАШИ ПЕРСОНАЖИ</span>
            {adm && <a href='../acp'>
                <button className='ucp-simple-yellow-button moder-button' style={{
                    width: "10vw",
                    display: "inline-block",
                    transform: "translate(0, -15px)",
                    padding: "10px 20px",
                    backgroundColor: "rgba(255,255,255,0.1)",
                    backdropFilter: "blur(5px)",
                    border: "1px solid rgba(240, 173, 0, 1)",
                    color: "white",
                    marginLeft: "1%",
                }}>МОДЕРАЦИЯ
                </button>
            </a>
            }
            <div className="ucp-character-buttons-container">
                <Modal isOpen={modalIsOpen} onRequestClose={closeSubmitModal} style={{
                    overlay: {
                        position: 'fixed',
                        zIndex: 1020,
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        background: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    },
                    content: {
                        width: '50vw',
                        height: '30vh',
                        minHeight: '200px',
                        border: '1px solid white',
                        borderRadius: '30px',
                        background: 'rgba(255, 255, 255, 0.05)',
                        backdropFilter: 'blur(50px)',
                        overflowY: 'auto',
                        position: 'relative',
                        left: 'auto',

                        color: '#FFF',
                        margin: "0",
                        padding: "0",
                        transition: "0.2s",
                    }
                }} ariaHideApp={false}>
                    {submitModalContent}
                </Modal>
                {characters.map((character, index) => {
                    const [firstName, name, lastName] = character.name.toUpperCase().split(' '); // Разделяем имя и фамилию
                    const status = "character-information-body character-body charact-status-" + character.status;
                    const stats = "../ucp/statistics?id=" + character.id
                    var en_gender = ""
                    switch (character["gender"]) {
                        case 1:
                            en_gender = "human"
                            break
                        case 2:
                            en_gender = "elf";
                            break
                        case 4:
                            en_gender = "dwarf";
                            break
                        case 6:
                            en_gender = "nimf";
                            break
                    }
                    const en_sex = character["sex"] == 0 ? "male" : "female";
                    const variable = character["startSkinVariable"]
                    return (

                        <div className={status} key={index}>
                            <button onClick={() => openSubmitModal(character["id"])}></button>
                            <a href={stats} key={index}><img
                                src={'/media/' + en_gender + "_" + en_sex + "_" + variable + ".png"}></img></a>

                            <span>
                {firstName}
                                <br/>
                                {name}
                                <br/>
                                {lastName}
              </span>
                        </div>

                    );
                })}

                {Array(placeholdersNeeded)
                    .fill(null)
                    .map((_, index) => (
                        <a href='../ucp/create-character' key={index}>
                            <div className="character-information-body character-body" key={`placeholder-${index}`}>
                                <div className="create-character"></div>
                                <span>
                СОЗДАТЬ
                <br/>
                ПЕРСОНАЖА
              </span>
                            </div>
                        </a>
                    ))}

            </div>

        </div>
    );
}


const handleRetestCharacter = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const payload = Object.fromEntries(formData.entries());
    try {
        const response = await fetch(ucp_api + "retest-character", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
            },
            body: JSON.stringify({
                user_id: localStorage.getItem("user-id"),
                user_name: localStorage.getItem("user-login"),
                user_password: localStorage.getItem("user-password"),
                character_id: payload.character_id,
                character_prehistory: payload.character_prehistory,
                character_traits: payload.character_traits,
                character_skills: payload.character_skills,
                character_appearance: payload.character_appearance,
                role_situation_1: payload.id_situation1,
                answer_situation_1: payload.character_situation1,
                role_situation_2: payload.id_situation2,
                answer_situation_2: payload.character_situation2,
            }),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
        }
        if (response.ok) {
            if (response.headers.get('Content-Length') === '0') {
                throw new Error('Empty response body');
            }
            const data = await response.json();
            if (data === true) {
                window.location.href = "/ucp/";
            }

        } else {
            const error = await response.json();
            console.error('Ошибка:', error);

        }
    } catch (err) {
        console.error('Ошибка соединения:', err);
    }
}


function UCPCreateCharacterRender() {
    const ucp_get_situations = ucp_api + "get-role-situations";
    const [textSituation1, setTextSituation1] = useState([]);
    const [textSituation2, setTextSituation2] = useState([]);
    const [toast, setToast] = useState(null);

    const handleCreateCharacter = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());
        if (Object.values(payload).some(value => value.trim() === "")) {
            alert("Требуется заполнить все поля!");
            return;
        }
        try {
            const response = await fetch(ucp_api + "create-character", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                },
                body: JSON.stringify({
                    user_id: localStorage.getItem("user-id"),
                    user_name: localStorage.getItem("user-login"),
                    user_password: localStorage.getItem("user-password"),
                    character_sex: payload.sex,
                    character_race: payload.race,
                    character_name: payload.character_name,
                    character_prehistory: payload.character_prehistory,
                    character_traits: payload.character_traits,
                    character_skills: payload.character_skills,
                    character_appearance: payload.character_appearance,
                    role_situation_1: payload.id_situation1,
                    role_answer_1: payload.character_situation1,
                    role_situation_2: payload.id_situation2,
                    role_answer_2: payload.character_situation2,
                    character_skinVariable: payload.selected_skin,
                }),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
            }
            if (response.ok) {
                if (response.headers.get('Content-Length') === '0') {
                    throw new Error('Empty response body');
                }
                const data = await response.json();

                switch (data.code) {
                    case 200:
                        window.location.href = "/ucp/";
                        break;
                    default:
                        console.log(data.status);
                        setToast({ message: data.status, type: "error" });

                }

            } else {
                const error = await response.json();
                console.error('Ошибка:', error);

            }
        } catch (err) {
            console.error('Ошибка соединения:', err);
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(ucp_get_situations, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                    body: JSON.stringify({
                        user_id: localStorage.getItem("user-id"),
                        user_name: localStorage.getItem("user-login"),
                        user_password: localStorage.getItem("user-password"),
                    }),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                setTextSituation1(result.situations[0])
                setTextSituation2(result.situations[1])
            } catch (err) {
                fetchData();
                console.error(err.message);
            }
        };
        fetchData();
    }, []);
    const [val, setVal] = useState("");
    const [kventa, setKventa] = useState("");
    const [traits, setTraits] = useState("");
    const [skills, setSkills] = useState("");
    const [appearance, setAppearance] = useState("");
    const [sex, setSex] = useState("male");
    const [race, setRace] = useState("human");
    const [situation1, setSituation1] = useState("");
    const [situation2, setSituation2] = useState("");
    const [skin, setSkin] = useState(1);

    const availableSkins = {
        "human": {
            "male": 6, 
            "female": 6
        },
        "elf": {
            "male": 1,
            "female": 1
        },
        "dwarf": {
            "male": 1,
            "female": 0
        },
        "nimf": {
            "male": 0,
            "female": 1
        }

    }

    const handleRaceChange = (selectedRace) => {
        setRace(selectedRace);
        if (selectedRace === 'nimf') {
            setSex('female');
        }
        if (selectedRace === 'dwarf') {
            setSex('male');
        }
        setSkin(1);
    };

    const handleSexChange = (selectedSex) => {
        if (race !== 'nimf' || race !== 'dwarf') {
            setSex(selectedSex);
        }
        setSkin(1);
    };

    const handleSkinPrev = () => {
        if (skin > 1) {
            setSkin(skin - 1)
        }
    }

    const handleSkinNext = () => {
        if (skin < availableSkins[race][sex]) {
            setSkin(skin + 1)
        }
    }

    return (
        <div>
            {toast && <ToastMessage message={toast.message} type={toast.type} onClose={() => setToast(null)}/>}
            <span className="ucp-title-pers">СОЗДАНИЕ ПЕРСОНАЖА</span>
            <div className='ucp-two-blocks-container ucp-two-blocks-container-create-person'>
                <div className='character-body'>
                    <img src={"/media/" + race + "_" + sex + "_" + skin + ".png"}></img>
                    <span>{(val.split(" "))[0].toUpperCase()}<br/>{(val.split(" ")).length > 1 ? (val.split(" "))[1].toUpperCase() : ""}<br/>{(val.split(" ")).length > 2 ? (val.split(" "))[2].toUpperCase() : ""}</span>
                </div>
                <SimpleBar className='ucp-second-container'>
                    <form onSubmit={handleCreateCharacter}>
                        <span>ВЫБОР ПОЛА</span>
                        <div className='ucp-buttons-container'>
                            <div className="ucp-radio-button">
                                <input type="radio" id="male" name="sex" value="male"
                                       onChange={(e) => handleSexChange(e.target.value)} disabled={race === 'nimf'}
                                       checked={sex === 'male'} defaultChecked/>
                                <label htmlFor="male">МУЖЧИНА</label>

                                <input type="radio" id="female" name="sex" value="female"
                                       onChange={(e) => handleSexChange(e.target.value)} disabled={race === 'dwarf'}
                                       checked={sex === 'female'}/>
                                <label htmlFor="female">ЖЕНЩИНА</label>
                            </div>
                        </div>
                        <span>ВЫБОР РАСЫ</span>
                        <div className='ucp-buttons-container'>
                            <div className="ucp-radio-button">
                                <input type="radio" id="human" name="race" value="human"
                                       onChange={(e) => handleRaceChange(e.target.value)} defaultChecked/>
                                <label htmlFor="human">ЧЕЛОВЕК</label>

                                <input type="radio" id="dwarf" name="race" value="dwarf"
                                       onChange={(e) => handleRaceChange(e.target.value)}/>
                                <label htmlFor="dwarf">КРАСНОЛЮД</label>

                                <input type="radio" id="elf" name="race" value="elf"
                                       onChange={(e) => handleRaceChange(e.target.value)}/>
                                <label htmlFor="elf">ЭЛЬФ</label>

                                <input type="radio" id="nimf" name="race" value="nimf"
                                       onChange={(e) => handleRaceChange(e.target.value)}/>
                                <label htmlFor="nimf">НИМФА</label>
                            </div>
                        </div>
                        <span>ИМЯ ПЕРСОНАЖА</span>
                        <input type='text' name='character_name' className='ucp-simple-input-text'
                               placeholder='Имя персонажа' maxLength={24} minLength={2} value={val}
                               onChange={e => setVal(e.target.value.replace(/[^а-яА-Я ]/g, ""))}></input>
                        <span>КВЕНТА ПЕРСОНАЖА</span>
                        <textarea name="character_prehistory" className='ucp-simple-input-text'
                                  placeholder='Краткая предыстория персонажа' maxLength={500} minLength={20}
                                  value={kventa} onChange={e => setKventa(e.target.value.replace(/[&%#@*<>]/g, ""))}
                                  style={{minHeight: '180px'}}></textarea>
                        <textarea name="character_traits" className='ucp-simple-input-text'
                                  placeholder='Черты характера персонажа' maxLength={500} minLength={20} value={traits}
                                  onChange={e => setTraits(e.target.value.replace(/[&%#@*<>]/g, ""))}
                                  style={{minHeight: '180px'}}></textarea>
                        <textarea name="character_skills" className='ucp-simple-input-text'
                                  placeholder='Увлечения, умения, навыки' maxLength={500} minLength={20} value={skills}
                                  onChange={e => setSkills(e.target.value.replace(/[&%#@*<>]/g, ""))}
                                  style={{minHeight: '180px'}}></textarea>
                        <textarea name="character_appearance" className='ucp-simple-input-text'
                                  placeholder='Внешний вид, особые приметы, привычки' maxLength={500} value={appearance}
                                  onChange={e => setAppearance(e.target.value.replace(/[&%#@*<>]/g, ""))}
                                  style={{minHeight: '180px'}}></textarea>
                        <span>РОЛЕВЫЕ СИТУАЦИИ</span>
                        <div className='ucp-simple-info-block'>{textSituation1["content"]}</div>
                        <input type='hidden' name="id_situation1" value={textSituation1["id"]}></input>
                        <textarea name="character_situation1" className='ucp-simple-input-text'
                                  placeholder='Ответ на ролевую ситуацию' maxLength={400} minLength={20}
                                  value={situation1}
                                  onChange={e => setSituation1(e.target.value.replace(/[&%#@*<>]/g, ""))}
                                  style={{minHeight: '150px'}}></textarea>
                        <div className='ucp-simple-info-block'>{textSituation2["content"]}</div>
                        <input type='hidden' name="id_situation2" value={textSituation2["id"]}></input>
                        <textarea name="character_situation2" className='ucp-simple-input-text'
                                  placeholder='Ответ на ролевую ситуацию' maxLength={400} minLength={20}
                                  value={situation2}
                                  onChange={e => setSituation2(e.target.value.replace(/[&%#@*<>]/g, ""))}
                                  style={{minHeight: '150px'}}></textarea>
                        <input type='hidden' name='selected_skin' value={skin}/>
                        <button
                            type='submit'
                            className='ucp-simple-yellow-button'
                            disabled={val.length < 5}
                        >
                            ЗАВЕРШИТЬ СОЗДАНИЕ ПЕРСОНАЖА
                        </button>


                    </form>
                </SimpleBar>
            </div>
            <div className='ucp-select-skins-container'>
            <button className='ucp-button-previous' onClick={handleSkinPrev}></button>
                <span>0{skin}/0{availableSkins[race][sex]}</span>
                <button className='ucp-button-next' onClick={handleSkinNext}></button>
            </div>
        </div>
    );
}


function UCPCharacterStatisticsRender() {
    const [loading, setLoading] = useState(true); // Состояние загрузки
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const ucp_get_character = ucp_api + "get-character-info";
    const ucp_get_notifications = ucp_api + "get-notifications";
    const ucp_get_situation = ucp_api + "get-role-situation"
    const [characterInfo, setCharacterInfo] = useState([])
    const [situation1, setSituation1] = useState([])
    const [situation2, setSituation2] = useState([])
    const [notifications, setNotifications] = useState([])
    const [full, setFull] = useState(-1)
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(ucp_get_character, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                    body: JSON.stringify({
                        user_id: localStorage.getItem("user-id"),
                        user_name: localStorage.getItem("user-login"),
                        user_password: localStorage.getItem("user-password"),
                        character_id: id,
                    }),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                setCharacterInfo(result)
            } catch (err) {
                console.error(err.message);
            } finally {
                setLoading(false)
            }
        };
        const getNotifications = async () => {
            try {
                const response = await fetch(ucp_get_notifications, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                    body: JSON.stringify({
                        user_id: localStorage.getItem("user-id"),
                        user_name: localStorage.getItem("user-login"),
                        user_password: localStorage.getItem("user-password"),
                        character_id: id,
                    }),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                setNotifications(result)
            } catch (err) {
                console.error(err.message);
            }
        };

        fetchData()
        getNotifications()

    }, []);
    useEffect(() => {
        const getSituation1 = async (id) => {
            try {
                const response = await fetch(ucp_get_situation, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                    body: JSON.stringify({
                        user_id: localStorage.getItem("user-id"),
                        user_name: localStorage.getItem("user-login"),
                        user_password: localStorage.getItem("user-password"),
                        situation_id: id,
                    }),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                setSituation1(result)
            } catch (err) {
                console.error(err.message);
            }
        };
        const getSituation2 = async (id) => {
            try {
                const response = await fetch(ucp_get_situation, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                    body: JSON.stringify({
                        user_id: localStorage.getItem("user-id"),
                        user_name: localStorage.getItem("user-login"),
                        user_password: localStorage.getItem("user-password"),
                        situation_id: id,
                    }),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                setSituation2(result)
            } catch (err) {
                console.error(err.message);
            }
        };
        if (characterInfo && characterInfo.idSituation1 && characterInfo.idSituation2) {
            getSituation1(characterInfo.idSituation1);
            getSituation2(characterInfo.idSituation2);
        }
    }, [characterInfo]); // Эффект срабатывает, когда `characterInfo` обновляется
    if (loading) {
        return ("Loading...")
    }
    const retest_link = "retest?id=" + characterInfo["id"];
    var status = "";
    switch (characterInfo["status"]) {
        case 0:
            status = "На рассмотрении"
            break
        case 1:
            status = "Одобрен"
            break
        case 2:
            status = "Отклонен"
            break
        case 4:
            status = "На ретесте"
            break
        default:
            status = "Определение..."
            break
    }

    var gender = "";
    switch (characterInfo["gender"]) {
        case 1:
            gender = "Человек"
            break
        case 2:
            gender = "Эльф";
            break
        case 3:
            gender = "Гном";
            break
        case 4:
            gender = "Краснолюд";
            break
        case 5:
            gender = "Низушек";
            break
        case 6:
            gender = "Нимфа";
            break
        case 7:
            gender = "Вампир";
            break
    }
    var en_gender = ""
    switch (characterInfo["gender"]) {
        case 1:
            en_gender = "human"
            break
        case 2:
            en_gender = "elf";
            break
        case 4:
            en_gender = "dwarf";
            break
        case 6:
            en_gender = "nimf";
            break
    }
    const en_sex = characterInfo["sex"] == 0 ? "male" : "female";

    const handleShowDescNotification = (id) => {
        if (full !== id) {
            setFull(id)
        } else setFull(-1)
    }

    return (
        <div className='ucp-main-statistic'>
            <button className='ucp-simple-blur-button ucp-button-back inline-button' style={{marginTop: "5vh"}}
                    onClick={(e) => {
                        window.location.href = "/ucp"
                    }}>НАЗАД
            </button>
            <div className="ucp-title-margin"></div>
            <div className='ucp-two-blocks-container'>
                <div className='character-body'>
                    <img
                        src={"/media/" + en_gender + "_" + en_sex + "_" + characterInfo["startSkinVariable"] + ".png"}></img>
                    <span>{(characterInfo["name"]).split(" ")[0].toUpperCase()}<br/>{(characterInfo["name"].split(" ")).length > 1 ? (characterInfo["name"].split(" "))[1].toUpperCase() : ""}<br/>{(characterInfo["name"].split(" ")).length > 2 ? (characterInfo["name"].split(" "))[2].toUpperCase() : ""}</span>
                </div>
                <SimpleBar className='ucp-second-container'>

                    <span className='unbounded-font'>УВЕДОМЛЕНИЯ</span>
                    {notifications.map((notification, index) => {
                        var desc;
                        var content = ""
                        if (notification.content.includes("[") && notification.content.includes("]")) {
                            if (notification.content.includes("[/ban]")) desc = "Данное наказание ограничивает игру на сервере на определённое количество дней или навсегда."
                            if (notification.content.includes("[/unban]")) desc = "Теперь Вы можете продолжить игру без каких-либо ограничений."
                            if (notification.content.includes("[/unwarn]")) desc = "Теперь Вы можете продолжить игру без каких-либо ограничений."
                            if (notification.content.includes("[/warn]")) desc = "Будьте осторожны, получение новых предупреждений может привести к блокировке!"
                            if (notification.content.includes("[/ajail]")) desc = "Данное наказание ограничивает игру вашего персонажа на некоторый промежуток времени."
                            content = notification.content
                            content = content.replace("[/ajail]", "").replace('[/ban]', '').replace('[/unban]', '').replace('[/warn]', '').replace('[/unwarn]', '');
                            content = content[1].toLowerCase() + content.slice(2)
                            content = notification.admin_name + " " + content
                        } else {
                            content = notification.content

                            desc = "Комментарий от администратора: " + notification.comment
                            if (content.includes("одобрил")) {
                                desc += "\n\n\n\Приятной игры на Medieval Role Play!"
                            }

                        }

                        if (full === index) {

                            return (
                                <div className='ucp-simple-info-block yellow-shadow left-text full-desc'
                                     style={{cursor: "pointer"}} key={index} onClick={() => {
                                    handleShowDescNotification(index)
                                }}>{content} <br/><br/>{desc}</div>
                            )
                        } else {
                            return (
                                <div className='ucp-simple-info-block yellow-shadow left-text'
                                     style={{cursor: "pointer"}} key={index} onClick={() => {
                                    handleShowDescNotification(index)
                                }}>{content}</div>
                            )
                        }
                    })}
                    <span className='unbounded-font'>СТАТИСТИКА</span>
                    <h1>ДАТА РЕГИСТРАЦИИ</h1>
                    <div
                        className='ucp-simple-info-block yellow-shadow'>{(characterInfo["createDate"].split("T")[0]).split("-")[2] + "." + (characterInfo["createDate"].split("T")[0]).split("-")[1] + "." + (characterInfo["createDate"].split("T")[0]).split("-")[0]}</div>
                    <h1>ID ПЕРСОНАЖА</h1>
                    <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["id"]}</div>
                    <h1>СТАТУС</h1>
                    <div className='ucp-simple-info-block yellow-shadow'>{status.toUpperCase()}</div>
                    <h1>ПОЛ</h1>
                    <div
                        className='ucp-simple-info-block yellow-shadow'>{characterInfo["sex"] == 0 ? "МУЖЧИНА" : "ЖЕНЩИНА"}</div>
                    <h1>РАСА</h1>
                    <div className='ucp-simple-info-block yellow-shadow'>{gender.toUpperCase()}</div>
                    <h1>ИМЯ ПЕРСОНАЖА</h1>
                    <div
                        className='ucp-simple-info-block yellow-shadow'>{characterInfo["name"].replace("_", " ").toUpperCase()}</div>
                    <h1>КВЕНТА ПЕРСОНАЖА</h1>
                    <h1>ПРЕДЫСТОРИЯ</h1>
                    <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["prehistory"]}</div>
                    <h1>ЧЕРТЫ ХАРАКТЕРА</h1>
                    <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["traits"]}</div>
                    <h1>НАВЫКИ, УВЛЕЧЕНИЯ</h1>
                    <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["skills"]}</div>
                    <h1>ВНЕШНИЕ ПРИМЕТЫ</h1>
                    <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["appearance"]}</div>

                    <h1>РОЛЕВЫЕ СИТУАЦИИ</h1>
                    <div className='ucp-simple-info-block yellow-shadow'>{situation1["content"]}</div>
                    <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["answerSituation1"]}</div>
                    <div className='ucp-simple-info-block yellow-shadow'>{situation2["content"]}</div>
                    <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["answerSituation2"]}</div>

                    {characterInfo["status"] === 4 && (
                        <button className="ucp-simple-yellow-button" onClick={(e) => {
                            window.location.href = retest_link
                        }}>ПРОЙТИ РЕТЕСТ</button>
                    )}

                </SimpleBar>
            </div>
        </div>
    );
}


function UCPRetestCharacterRender() {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const ucp_get_situations = ucp_api + "get-role-situations";
    const ucp_get_character = ucp_api + "get-character-info"
    const [textSituation1, setTextSituation1] = useState([]);
    const [textSituation2, setTextSituation2] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(ucp_get_situations, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                    body: JSON.stringify({
                        user_id: localStorage.getItem("user-id"),
                        user_name: localStorage.getItem("user-login"),
                        user_password: localStorage.getItem("user-password"),
                    }),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                setTextSituation1(result.situations[0])
                setTextSituation2(result.situations[1])
            } catch (err) {
                console.error(err.message);
            }
            try {
                const response = await fetch(ucp_get_character, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                    body: JSON.stringify({
                        user_id: localStorage.getItem("user-id"),
                        user_name: localStorage.getItem("user-login"),
                        user_password: localStorage.getItem("user-password"),
                        character_id: id,
                    }),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                setKventa(result.prehistory)
                setTraits(result.traits)
                setSkills(result.skills)
                setAppearance(result.appearance)
                setVal(result.name)
                var en_gender = ""
                switch (result["gender"]) {
                    case 1:
                        en_gender = "human"
                        break
                    case 2:
                        en_gender = "elf";
                        break
                    case 4:
                        en_gender = "dwarf";
                        break
                    case 6:
                        en_gender = "nimf";
                        break
                }
                setGender(en_gender)
                const en_sex = result["sex"] == 0 ? "male" : "female";
                setSex(en_sex)
                setSkinVariable(result.startSkinVariable)
            } catch (err) {
                console.error(err.message);
            }
        };
        fetchData();
    }, []);
    const [val, setVal] = useState("");
    const [kventa, setKventa] = useState("");
    const [traits, setTraits] = useState("");
    const [skills, setSkills] = useState("");
    const [appearance, setAppearance] = useState("");
    const [situation1, setSituation1] = useState("");
    const [situation2, setSituation2] = useState("");
    const [skinVariable, setSkinVariable] = useState(1)
    const [gender, setGender] = useState("")
    const [sex, setSex] = useState("")


    return (
        <div>
            <span className="ucp-title">РЕТЕСТ</span>
            <div className='ucp-two-blocks-container'>
                <div className='character-body'>
                    <img src={"/media/" + gender + "_" + sex + "_" + skinVariable + ".png"}></img>
                    <span>{(val.split(" "))[0].toUpperCase()}<br/>{(val.split(" ")).length > 1 ? (val.split(" "))[1].toUpperCase() : ""}<br/>{(val.split(" ")).length > 2 ? (val.split(" "))[2].toUpperCase() : ""}</span>
                </div>
                <SimpleBar className='ucp-second-container'>
                    <form onSubmit={handleRetestCharacter}>
                        <h1>ИМЯ ПЕРСОНАЖА</h1>
                        <div className='ucp-simple-info-block'>{val}</div>
                        <h1>КВЕНТА ПЕРСОНАЖА</h1>
                        <textarea name="character_prehistory" className='ucp-simple-input-text'
                                  placeholder='Краткая предыстория персонажа' maxLength={500} minLength={10}
                                  value={kventa} onChange={e => setKventa(e.target.value.replace(/[&%#@*<>]/g, ""))}
                                  style={{minHeight: '180px'}}></textarea>
                        <textarea name="character_traits" className='ucp-simple-input-text'
                                  placeholder='Черты характера персонажа' maxLength={500} minLength={10} value={traits}
                                  onChange={e => setTraits(e.target.value.replace(/[&%#@*<>]/g, ""))}
                                  style={{minHeight: '180px'}}></textarea>
                        <textarea name="character_skills" className='ucp-simple-input-text'
                                  placeholder='Увлечения, умения, навыки' maxLength={500} minLength={10} value={skills}
                                  onChange={e => setSkills(e.target.value.replace(/[&%#@*<>]/g, ""))}
                                  style={{minHeight: '180px'}}></textarea>
                        <textarea name="character_appearance" className='ucp-simple-input-text'
                                  placeholder='Внешний вид, особые приметы, привычки' maxLength={500} minLength={10}
                                  value={appearance}
                                  onChange={e => setAppearance(e.target.value.replace(/[&%#@*<>]/g, ""))}
                                  style={{minHeight: '180px'}}></textarea>
                        <h1>РОЛЕВЫЕ СИТУАЦИИ</h1>
                        <div className='ucp-simple-info-block'>{textSituation1["content"]}</div>
                        <input type='hidden' name="id_situation1" value={textSituation1["id"]}></input>
                        <textarea name="character_situation1" className='ucp-simple-input-text'
                                  placeholder='Ответ на ролевую ситуацию' maxLength={400} minLength={10}
                                  value={situation1}
                                  onChange={e => setSituation1(e.target.value.replace(/[&%#@*<>]/g, ""))}
                                  style={{minHeight: '150px'}}></textarea>
                        <div className='ucp-simple-info-block'>{textSituation2["content"]}</div>
                        <input type='hidden' name="id_situation2" value={textSituation2["id"]}></input>
                        <textarea name="character_situation2" className='ucp-simple-input-text'
                                  placeholder='Ответ на ролевую ситуацию' maxLength={400} minLength={10}
                                  value={situation2}
                                  onChange={e => setSituation2(e.target.value.replace(/[&%#@*<>]/g, ""))}
                                  style={{minHeight: '150px'}}></textarea>
                        <input type='hidden' name='character_id' value={id}/>
                        <button type='submit' className='ucp-simple-yellow-button'>ОТПРАВИТЬ РЕТЕСТ</button>

                    </form>
                </SimpleBar>
            </div>
        </div>
    );
}


function UCPSettingsRender() {
    const [loading, setLoading] = useState(true);
    const ucp_get_user = ucp_api + "get-user-info";
    const [userInfo, setUserInfo] = useState()
    const [passw, setPassw] = useState("")
    const [isGAuthChecked, setIsGAuthChecked] = useState(false);
    const [gAuthSecretKey, setGAuthSecretKey] = useState("")

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(ucp_get_user, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                    body: JSON.stringify({
                        user_id: localStorage.getItem("user-id"),
                        user_name: localStorage.getItem("user-login"),
                        user_password: localStorage.getItem("user-password"),
                    }),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                setUserInfo(result)
                if(result.gauth_enabled) setIsGAuthChecked(true)
            } catch (err) {
                console.error(err.message);
                fetchData()
            } finally {
                setLoading(false)
            }
        };
        fetchData()

    }, []);

    const handleExit = () => {
        localStorage.clear()
        window.location.href = "../../"
    }

    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [isGAuthModalOpen, setGAuthModalOpen] = useState(false)

    const handleChangePassword = async () => {
        const result = await whirlpool(passw);
        if (result.toUpperCase() == localStorage.getItem("user-password")) {
            openLoginModal()
        }
    }
    const openLoginModal = () => {
        setModalIsOpen(true);
    };

    const closeLoginModal = () => {
        setModalIsOpen(false);
    };

    const handleConfirmTwoAuth = () => {
        setGAuthModalOpen(false)
    }


    // disable two auth request to the API
    const disableGAuthRequest = async () => {
        try {
            const response = await fetch(google_two_factor_api + "disable-two-auth", {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                },
                body: JSON.stringify({
                    user_id: localStorage.getItem("user-id"),
                    user_name: localStorage.getItem("user-login"),
                    user_password: localStorage.getItem("user-password"),
                }),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
            }
            else {
                if (response.headers.get('Content-Length') === '0') {
                    throw new Error('Empty response body');
                }
            }
        } catch (err) {
            console.error('Ошибка соединения:', err);
        }
    }

    const closeGAuthModal = () => {
        setGAuthModalOpen(false);
        setIsGAuthChecked(false);
        disableGAuthRequest()
    };


    // p.s. GOOGLE TWO-FACTOR AUTH SWITCH TOGGLED
    const handleToggle = async (event) => {
        const checked = event.target.checked;
        setIsGAuthChecked(checked)
        if(checked == true){
            setGAuthModalOpen(true)
            
            try {
                const response = await fetch(google_two_factor_api + "new-secret-key", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                    body: JSON.stringify({
                        user_id: localStorage.getItem("user-id"),
                        user_name: localStorage.getItem("user-login"),
                        user_password: localStorage.getItem("user-password"),
                    }),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
                }
                if (response.ok) {
                    if (response.headers.get('Content-Length') === '0') {
                        throw new Error('Empty response body');
                    }
                    const data = await response.json();
                    if(data.code == 200){
                        setGAuthSecretKey(data.object)
                    }
                    else{
                        console.log(data.status, ", code: ", data.code)
                        setGAuthSecretKey(data.status)
                    }
    
    
                } else {
                    const error = await response.json();
                    console.error('Ошибка:', error);
    
                }
            } catch (err) {
                console.error('Ошибка соединения:', err);
            }



        } else disableGAuthRequest(); // TODO: disabling GAuthenticator
      };

    const submitChangePassword = async (event) => {
        event.preventDefault();

        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());
        if (payload.password != payload.re_password) {
            return null;
        }
        try {
            const new_pass_hash = (await whirlpool(payload.password)).toUpperCase();
            const response = await fetch(ucp_api + "change-user-password", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
                },
                body: JSON.stringify({
                    user_id: localStorage.getItem("user-id"),
                    user_name: localStorage.getItem("user-login"),
                    user_password: localStorage.getItem("user-password"),
                    new_password: new_pass_hash,
                }),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
            }
            if (response.ok) {
                if (response.headers.get('Content-Length') === '0') {
                    throw new Error('Empty response body');
                }
                const data = await response.json();
                if (data === true) {
                    localStorage.setItem("user-password", new_pass_hash)
                    closeLoginModal()
                }


            } else {
                const error = await response.json();
                console.error('Ошибка:', error);

            }
        } catch (err) {
            console.error('Ошибка соединения:', err);
        }
    }

    const changePassContent = (
        <div className='login-modal-content-container'>
            <h1 className='auth-title' style={{fontSize: "32px"}}>СМЕНА ПАРОЛЯ</h1>
            <form onSubmit={submitChangePassword}>
                <input className='auth-input-form' placeholder='Новый пароль*' name="password" type='password'></input>
                <input className='auth-input-form' placeholder='Повторите новый пароль*' name="re_password"
                       type='password'></input>
                <button className='auth-input-button-login' type='submit' style={{marginTop: "5%"}}>СМЕНИТЬ ПАРОЛЬ
                </button>
            </form>
        </div>
    );


    const GAuthModalContent = (
        <div className='login-modal-content-container'>
            <h1 className='auth-title' style={{fontSize: "32px", textAlign: "center"}}>НАСТРОЙКА ДВУХФАКТОРНОЙ АУТЕНТИФИКАЦИИ</h1>
            <div>
                <span>Пожалуйста, остканируйте данный QR код или воспользуйтесь следующим кодом для настройки двухфакторной аутентификации:</span>
                <br></br>
                <span style={{fontSize: "18pt", display: "block", marginTop: "20px"}}>{gAuthSecretKey !== "" ? gAuthSecretKey : false}</span>
                <br></br>
                {GenerateQR(localStorage.getItem("user-login"), gAuthSecretKey)}
                <button className='auth-input-button-login'  style={{width:"100%"}} onClick={handleConfirmTwoAuth}>ПРИМЕНИТЬ</button>
            </div>
            
            
        </div>
    );


    const [page, setPage] = useState(0)

    function formatTimeWithOffset(timeString, offsetHours) {
        // Преобразуем строку в объект Date
        const date = new Date(timeString);

        // Прибавляем 3 часа
        date.setHours(date.getHours() + offsetHours);

        // Форматируем дату
        const formattedTime = date.toISOString().replace("T", " ").replace("Z", "").replace(".000", "");

        return formattedTime;
    }

    if (loading) {
        return ("Loading...")
    }
    return (
        <div style={{marginTop: "7vh"}} className='settings-content-container'>
            <button className='ucp-simple-blur-button ucp-button-back ucp-button-back-settings inline-button'
                    onClick={(e) => {
                window.location.href = "/ucp"
            }}>НАЗАД
            </button>
            <div className='ucp-radio-button inline-display custom-label' style={{marginBottom: "10vh"}}>
                <input type="radio" id="settings" name="page" value="settings" onChange={(e) => {
                    setPage(0)
                }} defaultChecked/>
                <label htmlFor="settings">ЛИЧНЫЕ ДАННЫЕ И БЕЗОПАСНОСТЬ</label>
                <input type='radio' id="history" name="page" value="history" onChange={(e) => {
                    setPage(1)
                }}></input>
                <label className={"custom-label-authorization"} htmlFor='history'>ИСТОРИЯ АВТОРИЗАЦИЙ</label>
            </div>
            {page === 0 && (
                <div>
                    <Modal isOpen={modalIsOpen} onRequestClose={closeLoginModal} style={{
                        overlay: {
                            position: 'fixed',
                            zIndex: 1020,
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            background: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        },
                        content: {
                            width: '50vw',
                            height: '40vh',
                            minHeight: '350px',
                            border: '1px solid white',
                            borderRadius: '30px',
                            background: 'rgba(255, 255, 255, 0.05)',
                            backdropFilter: 'blur(15px)',
                            overflowY: 'auto',
                            position: 'relative',
                            left: 'auto',

                            color: '#FFF',
                            margin: "0",
                            padding: "0",
                            transition: "0.2s",
                        }
                    }} ariaHideApp={false}>
                        {changePassContent}
                    </Modal>



                    <Modal isOpen={isGAuthModalOpen} onRequestClose={closeGAuthModal} style={{
                        overlay: {
                            position: 'fixed',
                            zIndex: 1020,
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            background: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        },
                        content: {
                            width: '50vw',
                            height: '65vh',
                            minHeight: '350px',
                            border: '1px solid white',
                            borderRadius: '30px',
                            background: 'rgba(255, 255, 255, 0.05)',
                            backdropFilter: 'blur(50px)',
                            overflowY: 'auto',
                            position: 'relative',
                            left: 'auto',

                            color: '#FFF',
                            margin: "0",
                            padding: "0",
                            transition: "0.2s",
                        }
                    }} ariaHideApp={false}>
                        {GAuthModalContent}
                    </Modal>



                    <div className='ucp-main-settings'>
                        <div
                            className='ucp-simple-info-block settings-page-info-width border-20 custom-info-block-settings button-with-profile-icon'>{localStorage.getItem("user-login")}</div>
                        <div
                            className='ucp-simple-info-block ucp-simple-info-block-settings settings-page-info-width border-20 custom-info-block-settings registration-label'
                            style={{marginLeft: "80px"}}>ЗАРЕГИСТРИРОВАН {userInfo.registrationDate.split("-")[2] + "." + userInfo.registrationDate.split("-")[1] + "." + userInfo.registrationDate.split("-")[0]}</div>
                    </div>
                    <p>Нет активной Premium подписки*</p>
                    <div className='two-inline-blocks'>
                        <h1>КОНТАКТНЫЙ E-MAIL</h1>
                        <div
                            className='ucp-simple-info-block ucp-simple-info-block-settings settings-page-info-width border-20 custom-info-block-settings'>{userInfo.email} </div>
                    </div>
                    <div className='two-inline-blocks' style={{width: "34%"}}>
                        <h1>ПАРОЛЬ</h1>
                        <input type="password"
                               className='ucp-simple-info-block ucp-simple-info-block-settings settings-page-info-width border-20 custom-info-block-settings'
                               placeholder='Введите действующий пароль...' maxLength={32} value={passw}
                               onChange={(e) => setPassw(e.target.value)}></input>
                    </div>
                    <button className='ucp-simple-yellow-button button-password'
                            // style={{display: "inline-block", width: "20%", marginLeft: "10px", height: "75px"}}
                            onClick={(e) => {
                                handleChangePassword()
                            }}>СМЕНИТЬ ПАРОЛЬ
                    </button>
                    <div className='two-inline-blocks'>
                        <h1>ФОРУМНЫЙ АККАУНТ</h1>
                        <div
                            className='ucp-simple-info-block ucp-simple-info-block-settings settings-page-info-width border-20 custom-info-block-settings label-development'>В
                            РАЗРАБОТКЕ
                        </div>
                    </div>
                    <div className='two-inline-blocks' style={{width: "25%"}}>
                        <h1 style={{
                            display: "inline-block",
                            marginRight: "30px",
                            fontFamily: "GilroySemiBold"
                        }}>TELEGRAM</h1>
                        <label className="switch">
                            <input type="checkbox" disabled/>
                            <span className="slider round"></span>
                        </label>
                    </div>
                    <div className='two-inline-blocks' style={{width: "35%"}}>
                        <h1 style={{
                            display: "inline-block",
                            marginRight: "30px",
                            fontFamily: "GilroySemiBold",
                            // fontSize: "30px"
                        }}>GOOGLE AUTHENTICATOR</h1>
                        <label className="switch">
                            <input type="checkbox" checked={isGAuthChecked} onChange={handleToggle}/>
                            <span className="slider round"></span>
                        </label>
                    </div>
                    <button className='ucp-simple-yellow-button' style={{
                        width: "12vw",
                        fontSize: "24px",
                        padding: "10px 20px",
                        borderRadius: "15px",
                        marginTop: "10px"
                    }} onClick={(e) => {
                        handleExit()
                    }}>ВЫХОД
                    </button>
                </div>
            )}
            {page === 1 && (
                <div>
                    <div className='ucp-simple-info-block ucp-settings-info'>
                        <div className="table-container">
                            <table>
                                <thead>
                                <tr>
                                    <th>Дата</th>
                                    <th>IP</th>
                                    <th>Клиент</th>
                                    <th>Платформа</th>
                                </tr>
                                </thead>
                                <tbody>
                                {userInfo.ucpAuthLogs.map((log, index) => {
                                    return (
                                        <tr key={log.id}>
                                            <td>{formatTimeWithOffset(log.time, 3)}</td>
                                            <td>{log.ip}</td>
                                            <td>{log.client}</td>
                                            <td>{log.platform}</td>
                                        </tr>
                                    )
                                })}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}


export const UCPMain = () => UCPMainRender()
export const UCPCreateCharacter = () => UCPCreateCharacterRender()
export const UCPCharacterStatistics = () => UCPCharacterStatisticsRender()
export const UCPRetestCharacter = () => UCPRetestCharacterRender()
export const UCPSettings = () => UCPSettingsRender()